module.exports = __webpack_public_path__ + "img/c8.80d10476.png";